import { ArrowLeftOutlined } from "@ant-design/icons";
import { Breadcrumb, Divider, theme } from "antd";
import type { BreadcrumbItemType } from "antd/es/breadcrumb/Breadcrumb";
import type { ReactNode } from "react";
import { Link, useNavigate } from "react-router";

interface SettingValue {
	valueString: string;
}

interface PublicSettings {
	PRIMARY_COLOR?: SettingValue;
	PRIMARY_LIGHT_COLOR?: SettingValue;
}

interface RouteItem extends BreadcrumbItemType {
	title: string;
	path?: string;
}

interface PageHeaderProps {
	publicSettings?: PublicSettings;
	routes?: RouteItem[];
	title: ReactNode;
	subtitle?: ReactNode;
	previous?: string;
	actions?: ReactNode;
}

const { useToken } = theme;

export const PageHeader = (props: PageHeaderProps) => {
	const { publicSettings, routes, title, subtitle, previous, actions } = props;

	const { token } = useToken();
	const navigate = useNavigate();

	return (
		<>
			<div className="flex flex-col mx-6 my-4">
				{routes && (
					<div className="flex justify-start mb-2">
						<Breadcrumb
							items={routes}
							itemRender={(route, _params, routes, _paths) => {
								const last = routes.indexOf(route) === routes.length - 1;

								return last ? (
									<span>{route.title}</span>
								) : (
									<Link to={route.path || ""}>{route.title}</Link>
								);
							}}
						/>
					</div>
				)}
				<div className="flex flex-wrap gap-y-4 justify-between items-center">
					<div className="flex flex-wrap items-center">
						{previous && (
							<ArrowLeftOutlined
								onClick={() => {
									navigate(previous);
								}}
								style={{ color: publicSettings?.PRIMARY_COLOR?.valueString }}
								className="text-lg mr-4"
							/>
						)}
						<div>
							<p
								className="text-lg font-bold"
								style={{ color: token.colorText }}
							>
								{title}
							</p>
							{subtitle && (
								<p className="text-sm text-gray-600 mt-1">{subtitle}</p>
							)}
						</div>
					</div>
					<div className="flex flex-wrap items-center">{actions}</div>
				</div>
			</div>
			<Divider style={{ marginTop: 0, marginBottom: 0 }} />
		</>
	);
};
